import { on } from 'delegated-events'

on('click', 'button.plan-mobile-action', e => {
  const button = e.currentTarget
  const planCard = button.closest('.plan-card')
  const table = planCard?.querySelector('.plan-mobile-table')
  if (!planCard || !table) return

  const isExpanded = table.classList.contains('plan-mobile-table--expanded')

  table.classList.toggle('plan-mobile-table--expanded', !isExpanded)
  planCard.classList.toggle('plan-card--expanded', !isExpanded)

  if (button.classList.contains('plan-mobile-action--footer') && isExpanded) {
    const top = planCard.getBoundingClientRect().top + window.scrollY - 64
    window.scrollTo({ top, behavior: 'smooth' })
  }
})
